import { Controller } from "@hotwired/stimulus";

export default class RevealController extends Controller {
	connect() {
		this._observer = new IntersectionObserver(
			(entries) => {
				for (const entry of entries) {
					if (!entry.isIntersecting) continue;

					entry.target.classList.add("vw-reveal--in");
					this._observer.unobserve(entry.target);
				}
			},
			{ rootMargin: "0px 0px -10% 0px", threshold: 0.1 },
		);

		for (const el of this.element.querySelectorAll("[data-reveal]")) {
			this._observer.observe(el);
		}
	}

	disconnect() {
		this._observer?.disconnect();
	}
}
